import React from 'react'

export const VideosScreenComponent = () => {
  return (
    <div>VideosScreenComponent</div>
  )
}
